import React from "react";
import "./HowClybourneWorks.css";

const HowClybourneWorks = () => {
    const steps = [
        {
            id: 1,
            title: "Connect Your Data",
            description: "Plug into our secure and easy-to-use platform.",
        },
        {
            id: 2,
            title: "Generate Insights",
            description: "AI-powered valuations delivered within 2 working days.",
        },
        {
            id: 3,
            title: <>Take<br />Action</>,
            description: "Use insights to plan growth, investment, or sale with confidence.",
        },
    ];

    return (
        <div className="background-color-light-grey">
            <div className="HowClybourneWorks-card-wrapper">
                <div className="highlight-card-how" />
                {/* <img
                className="visionary-background-img"
                src="/assets/images/About_page/Vector2.png"
                alt="Background"
            /> */}
                <div className="how-Clybourne-container">
                    <div className="about-us-text about-All">
                        <h1>How Clybourne Works?</h1>
                        <h2>Valuations Designed for Simplicity and Speed</h2>
                    </div>

                    <div className="stats-section">
                        <div className="stats-container">
                            {/* First card  */}
                            <div
                                className="HowClybourneWorks-card"
                                style={{ backgroundColor: "#233977" }}
                            >
                                <h2 className="green-text">{steps[0].title}</h2>
                                <p className="white-text-2">{steps[0].description}</p>
                            </div>

                            {/* Second card  */}


                            <div
                                className="HowClybourneWorks-card"
                                style={{ backgroundColor: "#233977" }}
                            >
                                <h2 className="green-text">{steps[1].title}</h2>
                                <p className="white-text-2">{steps[1].description}</p>
                            </div>

                            {/* Third card  */}
                            {/* <div className="HowClybourneWorks-card-wrapper"> */}

                            <div
                                className="HowClybourneWorks-card"
                                style={{ backgroundColor: "#233977" }}
                            >
                                <h2 className="green-text">{steps[2].title}</h2>
                                <p className="white-text-2">{steps[2].description}</p>
                            </div>
                            {/* </div> */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowClybourneWorks;
